import { GmapsMarker } from '@infodata-group/inf-commons-tools';
import { PathPoint } from '../path-point/path-point';
import { PathTypeEnum } from '../../../enum/path/path-type.enum';

export class PathMarker extends GmapsMarker {
  public type: PathTypeEnum;
  public pathPoint: PathPoint;

  constructor(id: string, pathPoint: PathPoint) {
    super(id, pathPoint.latitude, pathPoint.longitude);
    this.pathPoint = pathPoint;
  }
}
